import axios from "axios";
import {IMilestoneAggregation, IShipment, ICSR, IFinalDelivery} from "./Shipment.types";
import ShipmentsById from "./Shipment.test.data";

export default class ShipmentApi {

    static async getShipments({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        let route = "";
        if(rawQuery?.searchType === "quickTrack") route = "/Search";
        else if (rawQuery?.searchType === "milestone") route = "/SearchByDashboardMilestone";
        else return undefined;

        try {
            let res = await axios.post(`/Shipments${route}`, rawQuery.query);
            return res.data as IShipment[];
        } catch (e: any) {
            console.error('Could not search Shipments: ', e.message);
            return undefined;
        }
    }

    static async getCSRList({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.post(`/CSR/Search`, rawQuery);
            return res.data as ICSR[];
        } catch (e: any) {
            console.error('Could not get CSR data: ', e.message);
            return undefined;
        }
    }

    static async getFinalDeliveries({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.post(`/FinalDelivery/Search`, rawQuery);
            return res.data as IFinalDelivery[];
        } catch (e: any) {
            console.error('Could not get Final Delivery data: ', e.message);
            return undefined;
        }
    }

    static async getShipmentMilestoneAggregations({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.post(`/DashboardMilestones/Search`, rawQuery);
            return res.data as IMilestoneAggregation[];
        } catch (e: any) {
            console.error('Could not get Dashboard Milestones data: ', e.message);
            return undefined;
        }
    }

    static async getShipmentById({queryKey}: any) {
        const [_, referenceNumber] = queryKey;
        try {
            // let res = await axios.get(`/Shipments/${BOL}`);
            // return res.data as IShipment;
            // TODO: Replace with actual API Request
            return ShipmentsById.get(referenceNumber);
        } catch (e: any) {
            console.error('Could not get shipment: ', e.message);
            return undefined;
        }
    }
}